module.exports = __webpack_public_path__ + "static/media/middle.682cb065.png";